// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__yt4Ij","mainHeader":"Header_mainHeader__Xf7K2","imgContainer":"Header_imgContainer__7D4R4"};